import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DateUtil {

    compareDates(date1: string, date2: string): number {
        if (date1 < date2) {
            return 1;
        } else if (date1 > date2) {
            return -1;
        } else {
            return 0;
        }
    }

    supportsDateInput(): boolean {
        const input = document.createElement('input');
        const value = 'a';
        input.setAttribute('type', 'date');
        input.setAttribute('value', value);
        return (input.value !== value);
    }

}
